import AbstractFilter from './abstract-filter'
import moment from 'moment'

const moduleDateTimeIntervals = new AbstractFilter()

moduleDateTimeIntervals.state = () => ({
  items: [
    { from: moment().startOf('year').format('X'), to: moment().endOf('year').format('X') },
    { from: moment().add(1, 'year').startOf('year').format('X'), to: moment().add(1, 'year').endOf('year').format('X') }
  ],
  active: { from: '', to: '' },
  selected: { from: '', to: '' }
})

export default {
  namespaced: true,
  state: moduleDateTimeIntervals.state,
  mutations: moduleDateTimeIntervals.mutations
}
